import { CodetableWireFormat } from 'app/infrastructure/ui/form/types-codetable';
import { CaseData, ComplexValue } from 'app/types-shared';
import { WireBowtieCaseModel, BowtieCaseModel, BowtieCase } from '../types';
import { mapCaseNumber } from './map-case-number';

export const mapCaseData = (caseData: CaseData): BowtieCase => caseData
  ? {
    ...caseData,
    caseNumber: mapCaseNumber(caseData),
    caseType: caseData.fields?.CaseType?.values?.[0] || caseData.caseType,
    fields: {
      ...(caseData.fields || {}),
      Status: caseData.fields?.StatusTemp || caseData.fields?.Status
    }
  }
  : {} as BowtieCase;

export const mapCode = (code: CodetableWireFormat): ComplexValue<number> => ({
  value: code.v,
  description: code.d,
  backgroundColor: code.b,
  foregroundColor: code.f,
  icon: code.i
});

export const mapBowtieData = (bowtieData: WireBowtieCaseModel): BowtieCaseModel => ({
  anchors: bowtieData.anchors,
  cases: bowtieData.cases && bowtieData.cases?.map(mapCaseData) || [],
  otherConnections: bowtieData.otherConnections?.map(
    connection => ({
      caseId: connection.caseId,
      connectionType: mapCode(connection.connectionType),
      caseType: mapCode(connection.caseType),
      count: connection.count
    })
  )
});
